import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import TaskList from "@/pages/TaskList";
import BathSchedule from "@/pages/BathSchedule";
import PaymentControl from "@/pages/PaymentControl";
import PerformanceCharts from "@/pages/PerformanceCharts";
import Layout from "@/components/Layout";

function Protected({ children, parentOnly = false }) {
    const { user, isChild } = useAuth();
    if (user === null) {
        return <div className="min-h-screen grid place-items-center text-slate-500">Carregando...</div>;
    }
    if (!user) return <Navigate to="/login" replace />;
    if (parentOnly && isChild) return <Navigate to="/" replace />;
    return <Layout>{children}</Layout>;
}

function Shell() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Protected><Dashboard /></Protected>} />
                <Route path="/tarefas" element={<Protected><TaskList /></Protected>} />
                <Route path="/banho" element={<Protected><BathSchedule /></Protected>} />
                <Route path="/pagamentos" element={<Protected parentOnly><PaymentControl /></Protected>} />
                <Route path="/desempenho" element={<Protected><PerformanceCharts /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" richColors />
        </BrowserRouter>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <AppProvider>
                <Shell />
            </AppProvider>
        </AuthProvider>
    );
}
